import * as React from 'react';
import * as icons from './icons.js';

interface Props {
    'data-name': string;
    fill?: string;
    height?: string;
    width?: string;
}

export class Icon extends React.Component<Props> {

    findIcon(name, iconsObj = icons) {
        const icon = iconsObj[name];
        if (icon) {
            return icon;
        }
        return false;
    }

    svgShapes(svgData) {
        const svgElements = svgData.map((data, index) => {
            if (data.name === 'path') {
            return (<path key={`key${index}`} d={data.value.d} />);
            }
            if (data.name === 'circle') {
            return (<circle key={`key${index}`}
                cx={data.value.cx}
                cy={data.value.cy}
                r={data.value.r}
                />);
            }
        });
        return svgElements;
    }

    render(): JSX.Element {
        const icon = this.findIcon(this.props['data-name']);
        const props = {
            fill: this.props.fill,
            height: `${this.props.height || icon.height}px`,
            name: this.props['data-name'],
            viewBox: icon.viewBox,
            width: `${this.props.width || icon.width}px`,
        };

        const svgContent = icon ? this.svgShapes(icon.svgData) : '';

        return (
            <svg {...props} >
                {svgContent}
            </svg>
        );
    }
}
